import React from "react";

export const Item = ({ left, right }: { left: React.ReactNode; right: React.ReactNode }) => {
  // [&:last-of-type>div]:cw-border-transparent
  return (
    <div className="cw-relative [&:last-of-type>div.line]:cw-bottom-1/2">
      <div className="cw-flex cw-items-center cw-gap-4 cw-mb-2">
        <div>{left}</div>
        <div className="cw-w-full">{right}</div>
      </div>
      <div
        className="line cw-absolute cw-border-default cw-border-l cw-border-solid -cw-top-4 -cw-bottom-3 cw-z-[-1]"
        style={{
          left: 16, // expected item width of 32px
        }}
      />
    </div>
  );
};
